import { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTaskCaseDetailsNavigation } from '../../hooks/useTaskCaseDetailsNavigation';
import {
  fetchConnectedAgdFileRefs,
  findLinkedCaseRequestId,
  parseConnectedAgdFileRefList,
  type ConnectedAgdFileRef,
} from '../../services/connectedAgdFileRefs';

type ConnectedAgdFileRefReviewFieldProps = {
  caseRequestId: string;
  label: string;
  fileRef: string;
};

export function ConnectedAgdFileRefReviewField({
  caseRequestId,
  label,
  fileRef,
}: ConnectedAgdFileRefReviewFieldProps) {
  const { taskCasePath } = useTaskCaseDetailsNavigation();
  const [linkedItems, setLinkedItems] = useState<ConnectedAgdFileRef[]>([]);
  const refs = parseConnectedAgdFileRefList(fileRef);

  useEffect(() => {
    const id = caseRequestId.trim();
    if (!id || refs.length === 0) {
      setLinkedItems([]);
      return;
    }

    const controller = new AbortController();
    void fetchConnectedAgdFileRefs(id, controller.signal).then((res) => {
      if (controller.signal.aborted) return;
      if (!res.ok) {
        setLinkedItems([]);
        return;
      }
      setLinkedItems(res.items);
    });

    return () => controller.abort();
  }, [caseRequestId, fileRef]);

  return (
    <div className="ccr-review-field">
      <div className="ccr-review-lbl">{label}</div>
      <div className="ccr-review-val">
        {refs.length === 0 ? (
          '—'
        ) : (
          refs.map((ref, index) => {
            const linkedCaseRequestId = findLinkedCaseRequestId(linkedItems, ref);
            return (
              <Fragment key={`${ref}-${index}`}>
                {index > 0 ? ', ' : null}
                {linkedCaseRequestId ? (
                  <Link
                    to={taskCasePath({ caseRequestId: linkedCaseRequestId })}
                    className="linked-case-ref-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {ref}
                  </Link>
                ) : (
                  ref
                )}
              </Fragment>
            );
          })
        )}
      </div>
    </div>
  );
}
